var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphNewUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 8.75033V10.0003C18.3346 13.9287 18.3346 15.8929 17.1142 17.1133C15.8939 18.3337 13.9297 18.3337 10.0013 18.3337C6.07293 18.3337 4.10875 18.3337 2.88836 17.1133C1.66797 15.8929 1.66797 13.9287 1.66797 10.0003C1.66797 6.07195 1.66797 4.10777 2.88836 2.88738C4.10875 1.66699 6.07293 1.66699 10.0013 1.66699H11.2513",
    stroke: "#424242",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.832,
    cy: 4.16699,
    r: 2.5,
    stroke: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 11.6663L7.74278 9.7556C8.06821 9.43016 8.59585 9.43016 8.92129 9.7556L10.2428 11.0771C10.5682 11.4025 11.0958 11.4025 11.4213 11.0771L14.1654 8.33301M14.1654 8.33301V10.4163M14.1654 8.33301H12.082",
    stroke: "#424242",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphNewUp);
export default __webpack_public_path__ + "static/media/Graph New Up.b45f18e300b170adfb63acb4aa9c234d.svg";
export { ForwardRef as ReactComponent };